import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Logo } from "@/components/Logo";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";

export function LegalShell({ title, children }) {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-background">
      <header className="glass-nav sticky top-0 z-40 border-b border-slate-200">
        <div className="mx-auto flex h-16 max-w-4xl items-center justify-between px-5">
          <Link to="/"><Logo /></Link>
          <div className="flex items-center gap-5 text-sm text-slate-500">
            <Link to="/privacy" className="hover:text-navy">{t("lg.nav.privacy")}</Link>
            <Link to="/imprint" className="hover:text-navy">{t("lg.nav.imprint")}</Link>
            <Link to="/terms" className="hover:text-navy">{t("lg.nav.terms")}</Link>
            <LanguageSwitcher />
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-5 py-14">
        <h1 className="font-heading text-4xl font-extrabold text-navy">{title}</h1>
        <div className="mt-8 space-y-5 text-sm leading-relaxed text-slate-600">{children}</div>
      </main>
    </div>
  );
}

export function TermsContent() {
  const { t } = useTranslation();
  return (
    <>
      <p dangerouslySetInnerHTML={{ __html: t("lg.tm.intro") }} />
      {["h1", "h2", "h3", "h4", "h5"].map((h, i) => (
        <div key={h}>
          <h3 className="font-heading text-lg font-bold text-navy">{t(`lg.tm.${h}`)}</h3>
          <p className="mt-1" dangerouslySetInnerHTML={{ __html: t(`lg.tm.p${i + 1}`) }} />
        </div>
      ))}
    </>
  );
}

export default function Terms() {
  const { t } = useTranslation();
  return <LegalShell title={t("lg.termsTitle")}><TermsContent /></LegalShell>;
}
